import { useState, useEffect } from "react";
import React from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button
} from "reactstrap";
import Header from "components/Headers/Header.js";
import "../../assets/css/custom.css";
import 'assets/css/themecustom-style.css';
import { useParams } from "react-router-dom";
import { apiUrl } from '../../constant';
import axios from 'axios'; 
import { clientmanageService } from "../../services/clientmanageService.js";

const CompanyHouseFiling = () => {
  const params = useParams();
  const [companyDetails, setCompanyDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false); // State for error handling

  const {
    company_number,
    company_status,
    date_of_creation,
    registered_office_address,
    company_name,
    accounts,
    confirmation_statement,
    sic_codes
  } = companyDetails.overview || {};

  const officers = companyDetails.officers?.items || [];
  const pscs = companyDetails.psc?.items || [];
  const filings = companyDetails.filing_history?.items || [];
  const charges = companyDetails.charges?.items || [];

  useEffect(() => {
    getCompanyHouseData(params.cin_number);
  }, [params.cin_number]);

  const getCompanyHouseData = (company_number) => {
    setLoading(true);
    setError(null);  // Reset error state before making the request

    axios
      .get(`${apiUrl}/company-house/details/${company_number}`)
      .then((response) => {
        if (response.status !== 200 || !response.data) {
          throw new Error("No data found for this company number");
        }
        setCompanyDetails(response.data);
      })
      .catch((err) => {
        console.error(err);
        setError(err.message);  // Set the error message if the request fails
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDownload = () => {
    setLoading(true);
    clientmanageService.companyhouseDataPDF(params.cin_number)
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `companyhouse-${type}report-${Date.now()}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => {
        console.error("PDF download failed:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleDownloadFile = (metadataUrl, label = 'document') => {
    setLoading(true);
  
    clientmanageService.downloadCompanyHouseDocument(metadataUrl)
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${label}-${Date.now()}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => {
        console.error("Download failed:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col lg="12">
            <h3>Company House Details</h3>

            {loading ? (
              <p>Loading company details...</p>
            ) : error ? (
              <p>No data found for this company number.</p> // Show error message when no data is found
            ) : (
              <>
                <Button
                  className="dash-button"
                  color="danger"
                  type="button"
                  onClick={() => handleDownload()}
                >
                  📥 Download PDF Report
                </Button>

                <Card className="shadow">
                  <CardHeader>
                    <h4>{company_name || "Company Name"}</h4>
                  </CardHeader>
                  <CardBody>
                    <h5>📝 Company Overview</h5>
                    <p><strong>Company Number:</strong> {company_number}</p>
                    <p><strong>Status:</strong> {company_status}</p>
                    <p><strong>Incorporation Date:</strong> {date_of_creation}</p>
                    <p><strong>Address:</strong> {registered_office_address?.address_line_1}, {registered_office_address?.postal_code}</p>

                    <hr />

                    <h5>📅 Financial Info</h5>
                    <p><strong>Last Accounts Filed Date:</strong> {accounts?.last_accounts?.made_up_to || "N/A"}</p>
                    <p><strong>Next Accounts Due Date:</strong> {accounts?.next_due || "N/A"}</p>
                    <p><strong>Last Confirmation Statement with Updates:</strong> {confirmation_statement?.last_made_up_to || "N/A"}</p>
                    <p><strong>Nature of Business (SIC):</strong> {(sic_codes || []).join(', ') || "N/A"}</p>

                    <hr />

                    <h5>👤 Directors</h5>
                    <ul>
                      {officers.map((officer, i) => (
                        <li key={i}>
                          {officer.name} ({officer.officer_role}) — Appointed on: {officer.appointed_on}
                        </li>
                      ))}
                    </ul>

                    <h5>👥 Persons with Significant Control (Shareholders)</h5>
                    <ul>
                      {pscs.map((person, i) => (
                        <li key={i}>
                          {person.name || `${person?.name_elements?.forename || ''} ${person?.name_elements?.surname || ''}`}
                        </li>
                      ))}
                    </ul>

                    <h5>📄 Filing History (Top 5)</h5>
                    <ul className="list-unstyled">
                      {filings.slice(0, 5).map((filing, i) => (
                        <li key={i} className="mb-2">
                           <span style={{margin:"0px 15px"}}><strong>{filing.date}</strong> — {filing.description}</span>
                          
                          {filing.category && (
                            <span style={{margin:"0px 15px"}} className="badge bg-info ms-2">{filing.category}</span>
                          )}

                          {filing.links?.document_metadata && (
                            
                            <button
                            style={{margin:"0px 15px"}}
                              className="btn btn-sm btn-primary ms-2"
                              onClick={() => handleDownloadFile(filing.links.document_metadata, filing.description || filing.category)}
                            >
                              <i className="fas fa-download me-1"></i> 
                            </button>
                          )}
                        </li>
                      ))}
                    </ul>

                    <h5>💰 Charges</h5>
                    <p>{charges.length} charges found.</p>
                  </CardBody>
                </Card>
              </>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CompanyHouseFiling;
